import { mapState } from 'pinia';
import {
  useEditorStore,
} from '@/stores';

export default {
  computed: {
    ...mapState(useEditorStore, [
      'draftType',
    ]),
  },
  methods: {
    hasShape(mod) {
      const shape = mod?.options?.shape;
      return shape && shape !== 'default';
    },
    autoSizeEnabled(mod, canvas) {
      const canvasName = canvas || this.canvasName;
      return this.mode === 'EDIT'
        && (
          (canvasName === 'modules' && this.draftType !== 'board')
          || ['modalModules', 'notes'].includes(canvasName)
        )
        && (
          (mod?.type === 'text' && ['overflow', 'hidden'].includes(mod?.options?.overflow))
          || mod?.type === 'advanced_button'
        );
    },
    autoSizeShrinkEnabled(mod, canvas) {
      return this.autoSizeEnabled(mod, canvas)
        && !this.hasShape(mod)
        && mod?.type === 'text';
    },
  },
};
